// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3VRFi","requiredAsterisk":"Info_requiredAsterisk__27VcV"};